import { cdcLocations, covidHospLocations, fluSurvRegions, fluViewRegions, gftLocations, ghtLocations, nidssDengueLocations, nidssFluLocations, nowcastLocations, quidelLocations, sensorLocations, sensorNames, twitterLocations, wikiArticles, } from '../../data/data';
import { DEFAULT_ISSUE } from './utils';
// The following classes define default values for the various "data source" forms, and will store modifications to those values as the user interacts with the forms.
export class CdcSelections {
    constructor() {
        this.locations = cdcLocations[0].value;
    }
}
export class CovidcastSelections {
    constructor() {
        this.dataSource = '';
        this.signal = '';
        this.geoType = '';
        this.geoValue = '';
    }
}
export class PopHiveSelections {
    constructor() {
        this.signal = '';
        this.geoType = '';
        this.geoValue = '';
        this.extraKeys = '';
    }
}
export class NwssSelections {
    constructor() {
        this.signal = '';
        this.geoType = '';
        this.geoValue = '';
        this.extraKeys = '';
        this.fillMethod = 'source';
    }
}
export class CovidHospSelections {
    constructor() {
        this.states = covidHospLocations[0].value;
        this.issue = DEFAULT_ISSUE;
    }
}
export class FluSurvSelections {
    constructor() {
        this.locations = fluSurvRegions[0].value;
        this.issue = DEFAULT_ISSUE;
    }
}
export class FluViewSelections {
    constructor() {
        this.locations = fluViewRegions[0].value;
        this.issue = DEFAULT_ISSUE;
    }
}
export class FluViewClinicalSelections {
    constructor() {
        this.locations = fluViewRegions[0].value;
        this.issue = DEFAULT_ISSUE;
    }
}
export class GftSelections {
    constructor() {
        this.locations = gftLocations[0].value;
    }
}
export class GhtSelections {
    constructor() {
        this.locations = ghtLocations[0].value;
        this.query = '';
    }
}
export class NidssDengueSelections {
    constructor() {
        this.locations = nidssDengueLocations[0].value;
    }
}
export class NidssFluSelections {
    constructor() {
        this.locations = nidssFluLocations[0].value;
        this.issue = DEFAULT_ISSUE;
    }
}
export class NowcastSelections {
    constructor() {
        this.locations = nowcastLocations[0].value;
    }
}
export class QuidelSelections {
    constructor() {
        this.locations = quidelLocations[0].value;
    }
}
export class SensorSelections {
    constructor() {
        this.locations = sensorLocations[0].value;
        this.names = sensorNames[0].value;
    }
}
export class TwitterSelections {
    constructor() {
        this.locations = twitterLocations[0].value;
        this.resolution = 'daily';
    }
}
export class WikiSelections {
    constructor() {
        this.articles = wikiArticles[0].value;
        this.resolution = 'daily';
        this.hour = 0;
        this.useHour = false;
        this.language = 'en';
    }
}
// The FormSelections class defines the default form choice, stores changes to that choice, and holds references to the values used in each "data source" form.
export default class FormSelections {
    constructor() {
        this.dataSource = 'fluview';
        this.cdc = new CdcSelections();
        this.covidcast = new CovidcastSelections();
        this.covidHosp = new CovidHospSelections();
        this.pophive = new PopHiveSelections();
        this.nwss = new NwssSelections();
        this.fluSurv = new FluSurvSelections();
        this.fluView = new FluViewSelections();
        this.fluViewClinical = new FluViewClinicalSelections();
        this.gft = new GftSelections();
        this.ght = new GhtSelections();
        this.nidssDengue = new NidssDengueSelections();
        this.nidssFlu = new NidssFluSelections();
        this.nowcast = new NowcastSelections();
        this.quidel = new QuidelSelections();
        this.sensors = new SensorSelections();
        this.twitter = new TwitterSelections();
        this.wiki = new WikiSelections();
    }
}
